import { useQuery } from "@tanstack/react-query";
import {  fetchUsersTable } from "../../../../enums/queryFunction/Fetch";
import { useSearchParams } from "react-router-dom";
import { userTableParams } from "../DesktopUserListingPage";

export const USERS_TABLE = 'usersTable';

export function useGetUsersTable(page, size, q, sort, clinicId, active, withoutPets, withoutReservations) {
  const { data, isLoading, error } = useQuery({
    queryKey: [USERS_TABLE, page, size, q, sort,clinicId,active,withoutPets,withoutReservations],
    queryFn: () => fetchUsersTable(page, size, q, sort, clinicId, active, withoutPets, withoutReservations),
    keepPreviousData: true,
    staleTime: 5000,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, error };
}
